import { Switch as GlueSwitch } from '@tencent/glue-react-ui';
import { withAdpCombine } from '../../config/context/config';
export var Switch = withAdpCombine(GlueSwitch);